import { render, staticRenderFns } from "./file-zip.vue?vue&type=template&id=279c2890"
import script from "./file-zip.vue?vue&type=script&lang=js"
export * from "./file-zip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports